import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'keyvalue'
})
export class KeyValuePipe implements PipeTransform {

  transform(items: any = {}): any {
    let keys = Object.keys(items);
    let result = [];
    keys.map ( o =>{
      result.push({ key : o, value : items[o]});
    });
    return result;
  }

}
